import {get, pipe} from '@logistics-frontend/utils'
import {isPoint} from '@yandex-taxi/react-integration-api'

import type {Point} from 'src/shared/types'

export function isValidPoint(point: Point) {
  return pipe(point, get('address.coordinates'), isPoint)
}
